<template>
  <div>
    <Breadcrumb v-if="Array.isArray(menuPath) && menuPath.length > 0" />
    <iframe name='iframe-page' id="outLink" ref="outLink" class="page-iframe" frameborder="0" :src="url" @load="loadFrame" :style="{height}"></iframe>
  </div>
</template>

<script>
  import global from "@/mixins/global";
  import Breadcrumb from '../common/breadcrumb.vue'
  export default {
    name: "outLink",
    props: {
      url: {
        type: String,
        default: ''
      }
    },
    components: {
      Breadcrumb
    },
    data() {
      return {
        height: ''
      }
    },
    mixins: [global],
    mounted () {
      this.verifyOutlink()
      document.getElementById('outLink').src = this.url
    },
    methods: {
      loadFrame() {
        this.verifyOutlink()
        try {
          const iframe = document.getElementById('outLink')
          // const parent = document.getElementById('right-container')
          const iframeWindow = iframe.contentWindow
          const url = iframeWindow.contentWindow ? iframeWindow.contentWindow.location.href : ''
          // const url = iframeWindow.contentWindow.location.href // 写法报错
          if (url.includes('//open.haiziwang.com')) {
            location.href = url
          }
          // console.log(iframeWindow.document.body.scrollHeight)
          // setTimeout(function(){
          //   console.log(3, parent.offsetHeight, parent.scrollHeight)
          // }, 10000);


          // console.log(parent.offsetHeight, parent.scrollHeight)
          // this.height = `${parent.offsetHeight + parent.scrollHeight}px`
        } catch (e) {
          // console.log('shezhi')
          console.log(e)
        }
      },
      verifyOutlink() {
        // 链接必须是.haiziwang.com或.cekid.com域名，否则跳登录页
        let reg = /^(http(s)?:)?\/\/([a-zA-Z0-9][-a-zA-Z0-9]{0,62}\.)+(haiziwang|cekid)\.com([?#/].*)?$/i
        if (this.url && !reg.test(this.url)) {
          this.logout()
        }
      }
    }
  }
</script>

<style lang="scss" scoped>
</style>
